import { Page } from '../../types'
import Source from '../../../components/Source'
import ExternalLink from '../../../components/ExternalLink'

const render = () => {
    return <>
        <p>
            In your application, you will use gurobipy for acccessing Gurobi functionality like defining and solving a model.
            To install the library without internet access, or if there are other reasons not to use a package manager
            like pip or conda, follow the steps below.
        </p>
        <ul>
            <li>Download the appropriate wheel file for your platform from <ExternalLink href='https://pypi.org/project/gurobipy/#files'>PyPI</ExternalLink></li>
            <li>Copy it to the machine onto which you want to install Gurobi Optimizer for Python.</li>
            <li>In your shell/terminal, issue the following command, replacing <code>&lt;wheel-dir&gt;</code> with the local directory where the wheel files is downloaded:<br/>
            <code>python -m pip install --find-links &lt;wheel-dir&gt; --no-index gurobipy</code></li>
            <li><em>Note:</em> Ensure that you have write permissions within this Python installation.</li>
            <li><em>Note:</em> If you are using virtual environments, make sure to activate the virtual environment before installing Gurobi.</li>
        </ul>
        <Source href="https://support.gurobi.com/hc/en-us/articles/360044290292-Installing-Gurobi-for-Python"/>
    </>
}

const InstallPackagesWheel : Page<{}> = { title: 'Install gurobipy in offline mode', key: 'install-gurobipy-wheel', render }

export default InstallPackagesWheel